var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgThumbsDown = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 3.3334,
  d: "M28.334 23.334v-20M15 30.2l1.667-6.866H6.95a3.335 3.335 0 0 1-3.2-4.267L7.633 5.733a3.33 3.33 0 0 1 3.2-2.4h22.5a3.333 3.333 0 0 1 3.334 3.334V20a3.333 3.333 0 0 1-3.333 3.334h-4.6a3.33 3.33 0 0 0-2.984 1.85L20 36.667a5.217 5.217 0 0 1-5-6.466"
}))));
export default SvgThumbsDown;